export { default as SideSheet } from './src/SideSheet'
